import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="about" className="py-10 md:py-16 bg-white overflow-x-hidden">
            <div className="container mx-auto px-6">
                <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
                    {/* Image Side */}
                    <div className="w-full lg:w-1/2">
                        <div className="relative">
                            <div className="absolute -top-4 -left-4 w-24 h-24 bg-blue-100 rounded-full z-0"></div>
                            <img
                                src="/images/osmia-product.jpg"
                                alt="About Neubreze"
                                className="relative z-10 rounded-2xl shadow-2xl w-full h-auto"
                            />
                            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-gray-100 rounded-full z-0"></div>
                        </div>
                    </div>

                    {/* Text Side */}
                    <div className="w-full lg:w-1/2">
                        <h4 className="text-blue-800 font-bold uppercase tracking-widest mb-2 text-2xl md:text-base">
                            {t('about.label')}
                        </h4>
                        <h1 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-4 md:mb-6 leading-[1.1]">
                            {t('about.title1')} <br />{t('about.title2')}
                        </h1>
                        <p className="text-gray-500 text-[13px] md:text-lg mb-4 md:mb-6 leading-relaxed">
                            {t('about.desc1')}
                        </p>
                        <p className="text-gray-500 text-[14px] md:text-lg mb-6 md:mb-8 leading-relaxed">
                            {t('about.desc2')}
                        </p>

                        <div className="grid grid-cols-2 gap-4 md:gap-6">
                            <div className="border-l-4 border-blue-500 pl-4">
                                <h5 className="font-bold text-base md:text-lg text-gray-900">{t('about.key1_title')}</h5>
                                <p className="text-xs md:text-sm text-gray-500">{t('about.key1_desc')}</p>
                            </div>
                            <div className="border-l-4 border-blue-500 pl-4">
                                <h5 className="font-bold text-base md:text-lg text-gray-900">{t('about.key2_title')}</h5>
                                <p className="text-xs md:text-sm text-gray-500">{t('about.key2_desc')}</p>
                            </div>
                            <div className="border-l-4 border-blue-500 pl-4">
                                <h5 className="font-bold text-base md:text-lg text-gray-900">{t('about.key3_title')}</h5>
                                <p className="text-xs md:text-sm text-gray-500">{t('about.key3_desc')}</p>
                            </div>
                            <div className="border-l-4 border-blue-500 pl-4">
                                <h5 className="font-bold text-base md:text-lg text-gray-900">{t('about.key4_title')}</h5>
                                <p className="text-xs md:text-sm text-gray-500">{t('about.key4_desc')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
